import { inject, Injectable } from '@angular/core';
import { z, ZodError } from 'zod/v4';
import { ErrorHandlingService } from '../errorHandling/error-handling.service';

@Injectable({
  providedIn: 'root',
})
export class ValidatorService {
  private errorHandlingService: ErrorHandlingService =
    inject(ErrorHandlingService);

  validate<T>(
    query: T,
    schema: z.ZodType<T>,
    context: string = 'UnknownSchema'
  ): T {
    try {
      if (Array.isArray(query)) {
        query.forEach((item: T, index) => {
          try {
            schema.parse(item);
          } catch (error) {
            if (error instanceof ZodError) {
              this.errorHandlingService.handleFatal(
                `${context}[${index}] validation failed.`,
                error
              );
            }
            throw error;
          }
        });
      } else {
        schema.parse(query);
      }
    } catch (error) {
      if (error instanceof ZodError) {
        this.errorHandlingService.handleFatal(
          `${context} validation failed.`,
          error
        );
      }
    }
    return query;
  }
}
